import React, { FC } from 'react';

import AddIcon from '@material-ui/icons/Add';

interface IAddPaymentIconProps {
  textButton?: string;
  title: string;
}

const AddPaymentIcon: FC<IAddPaymentIconProps> = props => {
  const { textButton, title } = props;

  return (
    <div className="button-add-container">
      <div className="icon-container">
        <AddIcon className="add-card-icon" />
      </div>

      <span>{!!textButton ? textButton : title}</span>
    </div>
  );
};

export default AddPaymentIcon;
